module.exports = __webpack_public_path__ + "images/destinations/discord_webhook.png";